import { Component } from 'solid-js'
import GenerateImageOptionButton from './GenerateImageOptionButton'

const GenerateImageClothingOptions: Component<{
  updatePrompt: (value: string, replacePrompt: boolean) => void
  currentPrompt: string
}> = (props) => {
  return (
    <div class="flex flex-row flex-wrap gap-3">
      <GenerateImageOptionButton
        title="Summer dress"
        value="wearing a long summer dress"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('wearing a long summer dress')}
      />
      <GenerateImageOptionButton
        title="Bikini"
        value="wearing a bikini"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('wearing a bikini')}
      />
      <GenerateImageOptionButton
        title="Skirt"
        value="wearing a skirt"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('wearing a skirt')}
      />
      <GenerateImageOptionButton
        title="Mini-skirt"
        value="wearing a mini-skirt"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('wearing a mini-skirt')}
      />
      <GenerateImageOptionButton
        title="Latex skirt"
        value="wearing a latex skirt"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('wearing a latex skirt')}
      />
      <GenerateImageOptionButton
        title="Jeans"
        value="wearing jeans"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('wearing jeans')}
      />
      <GenerateImageOptionButton
        title="Lab coat"
        value="wearing a lab coat and shirt"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('wearing a lab coat and shirt')}
      />
      <GenerateImageOptionButton
        title="Teacher"
        value="wearing a pencil skirt with a blazer and a shirt, teaching in front of the class"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes(
          'wearing a pencil skirt with a blazer and a shirt, teaching in front of the class'
        )}
      />
      <GenerateImageOptionButton
        title="Pajamas"
        value="wearing comfy pajamas, sitting on the bed"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('wearing comfy pajamas, sitting on the bed')}
      />
      <GenerateImageOptionButton
        title="Tank top"
        value="wearing a tank top and shorts"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('wearing a tank top and shorts')}
      />
      <GenerateImageOptionButton
        title="Sport"
        value="wearing a sport outfit, in a gym"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('wearing a sport outfit, in a gym')}
      />
    </div>
  )
}

export default GenerateImageClothingOptions
